import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { AssetsUrlPipe } from '../../../pipes/assets-url.pipe';
import { UpaAsyncService } from '../../../services/upa-async.service';
import { redirectToUrl } from '../utils/navigation.utils';
import { HIGHLIGHT, COUPONS, BENEFITS } from '../utils/urls.constants';

@Component({
  selector: 'al-header-loyalty',
  standalone: true,
  imports: [CommonModule, AssetsUrlPipe],
  templateUrl: './header-loyalty.component.html',
  styleUrls: ['./header-loyalty.component.scss']
})
export class HeaderLoyaltyComponent {
  @Input() showHeader = true;
  @Input() isResolutionMobile = false;
  @Input() isClientNotEnrolled = false;
  @Input() isEnrolled = false;
  @Input() loadingIfoodInfo = false;
  @Input() source = '';


  upaAsyncService = inject(UpaAsyncService);

  goToHighlight() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'beneficios_destaques',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(HIGHLIGHT);
  }

  goToCoupons() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'beneficios_cupons',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(COUPONS);
  }

  goToBenefits() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'beneficios_volver',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(BENEFITS);
  }
}
